import { getCategoriesByType } from "../services/CategoryServices";

export const getCategories = async (onSuccess, categoryType) => {
    try {
        let response = await getCategoriesByType(categoryType);
        onSuccess(response.data)
    } catch (error) {
        
    }
};